import { useEffect } from "react";

function useOutsideAlerter(ref, callback) {

    const getParents = (elem) => {

        // Set up a parent array
        var parents = [];
    
        // Push each parent element to the array
        for ( ; elem && elem !== document; elem = elem.parentNode ) {
            parents.push(elem);
        }
    
        // Return our parent array
        return parents;
    };

    useEffect(() => {
        /**
         * Alert if clicked on outside of element
         */
        function handleClickOutside(event) {
            const parents = getParents(event.target);
            if (ref.current && !parents.includes(ref.current)) {
                callback()
            }
        }
        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref]);
}

export default useOutsideAlerter;